import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-branch-screen",
  "aria-label": "Режим работы филиала"
}
const _hoisted_2 = { class: "w-branch-intro" }
const _hoisted_3 = { class: "w-field w-branch-effective" }
const _hoisted_4 = { class: "w-branch-reload-row" }
const _hoisted_5 = { class: "w-branch-period" }
const _hoisted_6 = { class: "w-branch-key" }
const _hoisted_7 = { class: "w-branch-section-head" }
const _hoisted_8 = { class: "w-branch-week" }
const _hoisted_9 = ["open", "onToggle"]
const _hoisted_10 = {
  class: "w-branch-exception-section",
  "aria-label": "Особые даты"
}
const _hoisted_11 = { class: "w-branch-section-head" }
const _hoisted_12 = { class: "w-branch-exceptions" }
const _hoisted_13 = { class: "w-exception-head" }
const _hoisted_14 = { class: "w-field" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "w-field" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["aria-label", "onClick"]
const _hoisted_19 = {
  key: 0,
  class: "w-small w-muted"
}
const _hoisted_20 = { class: "w-branch-bottom" }
const _hoisted_21 = ["role"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "w-actions" }

import {
  computed, onBeforeUnmount, onMounted, reactive, ref,
} from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import {
  addDays, formatDate, hoursText, isValidDate, WEEKDAY_NAMES,
} from '~utils/calendarModel';
import BranchDayEditor from './BranchDayEditor.vue';

const MAX_CONFLICTS = 8;

export default /*@__PURE__*/_defineComponent({
  __name: 'BranchSchedule',
  setup(__props) {

const LONG_DATE: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };

const store = useScheduleStore();
const draft = computed(() => store.branchDraft);

// На телефоне дни недели свёрнуты, раскрытые запоминаются
const mobileQuery = window.matchMedia('(max-width: 650px)');
const isMobile = ref(mobileQuery.matches);
const expandedDays = reactive(new Set([0]));

const onMobileChange = (event: MediaQueryListEvent) => {
  isMobile.value = event.matches;
};

const onToggle = (index: number, event: Event) => {
  if (!isMobile.value) return;
  if ((event.target as HTMLDetailsElement).open) expandedDays.add(index);
  else expandedDays.delete(index);
};

// «Черновик · с 12 октября 2026 до 31 декабря 2026 · Europe/Moscow»
const periodText = computed(() => {
  const current = draft.value;
  if (!current) return '';
  const next = store.schedule.branchRules
    .filter((rule) => (
      rule.branchId === store.branchId && rule.effectiveFrom > current.effectiveFrom
    ))
    .sort((a, b) => a.effectiveFrom.localeCompare(b.effectiveFrom))[0];
  const from = isValidDate(current.effectiveFrom)
    ? formatDate(current.effectiveFrom, LONG_DATE)
    : 'выбранной даты';
  const until = next
    ? ` до ${formatDate(addDays(next.effectiveFrom, -1), LONG_DATE)}`
    : ' · до следующего изменения';
  const prefix = store.branchDirty ? 'Черновик · ' : '';
  return `${prefix}с ${from}${until} · ${store.currentBranch?.timeZone || 'время филиала'}`;
});

const feedback = computed(() => store.branchFeedback);

const feedbackText = computed(() => {
  const { result, saved } = feedback.value || {};
  if (!result?.ok) return result?.message || '';
  return saved
    ? 'Режим филиала сохранён.'
    : 'Режим проверен. Существующие записи пациентов не затронуты.';
});

const blockedCount = computed(() => feedback.value?.result.blockedSlotIds?.length || 0);

const conflicts = computed(() => (
  (feedback.value?.result.conflicts || []).slice(0, MAX_CONFLICTS)
));

onMounted(() => mobileQuery.addEventListener('change', onMobileChange));
onBeforeUnmount(() => mobileQuery.removeEventListener('change', onMobileChange));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (draft.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, _toDisplayString(_unref(store).currentBranch?.name), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(store).actorDoctor?.name || 'Пользователь') + " · управление режимом", 1)
          ]),
          _createElementVNode("label", _hoisted_3, [
            _cache[9] || (_cache[9] = _createTextVNode(" Действует с ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draft.value.effectiveFrom) = $event)),
              type: "date",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).markBranchEdited()))
            }, null, 544), [
              [
                _vModelText,
                draft.value.effectiveFrom,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(periodText.value), 1),
          _createElementVNode("button", {
            class: "w-button w-ghost",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).reloadBranch()))
          }, " Загрузить сохранённый режим ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, [
            _createVNode(_component_q_icon, { name: "apartment" }),
            _cache[10] || (_cache[10] = _createTextVNode(" Работа филиала ", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_q_icon, { name: "medical_services" }),
            _cache[11] || (_cache[11] = _createTextVNode(" Приём пациентов · внутри рабочего времени ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Недельный режим", -1)),
          _createElementVNode("button", {
            class: "w-button w-ghost",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).copyMondayToWeekdays()))
          }, [
            _createVNode(_component_q_icon, { name: "content_copy" }),
            _cache[12] || (_cache[12] = _createTextVNode(" Понедельник → будни ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draft.value.week, (day, index) => {
            return (_openBlock(), _createElementBlock("details", {
              key: day.weekday,
              class: "w-hours-detail",
              open: !isMobile.value || expandedDays.has(index),
              onToggle: ($event: any) => (onToggle(index, $event))
            }, [
              _createElementVNode("summary", null, [
                _createElementVNode("strong", null, _toDisplayString(_unref(WEEKDAY_NAMES)[day.weekday - 1]), 1),
                _createElementVNode("span", null, _toDisplayString(day.open.length ? `Приём ${_unref(hoursText)(day.intake)}` : 'Выходной'), 1)
              ]),
              _createVNode(BranchDayEditor, {
                kind: "week",
                index: index,
                title: _unref(WEEKDAY_NAMES)[day.weekday - 1]
              }, null, 8, ["index", "title"])
            ], 40, _hoisted_9))
          }), 128))
        ]),
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Особые даты", -1)),
            _createElementVNode("button", {
              class: "w-button w-ghost",
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).addException()))
            }, [
              _createVNode(_component_q_icon, { name: "add" }),
              _cache[14] || (_cache[14] = _createTextVNode(" Добавить дату ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(draft.value.exceptions, (day, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "w-exception-card"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _cache[16] || (_cache[16] = _createTextVNode(" Дата ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((day.date) = $event),
                      type: "date",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(store).markBranchEdited()))
                    }, null, 40, _hoisted_15), [
                      [
                        _vModelText,
                        day.date,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_16, [
                    _cache[17] || (_cache[17] = _createTextVNode(" Название ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((day.label) = $event),
                      type: "text",
                      maxlength: "80",
                      placeholder: "Например, сокращённый день",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).markBranchEdited()))
                    }, null, 40, _hoisted_17), [
                      [
                        _vModelText,
                        day.label,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "w-button w-ghost w-icon",
                    type: "button",
                    "aria-label": `Удалить особую дату ${index + 1}`,
                    onClick: ($event: any) => (_unref(store).removeException(index))
                  }, [
                    _createVNode(_component_q_icon, { name: "delete" })
                  ], 8, _hoisted_18)
                ]),
                _createVNode(BranchDayEditor, {
                  kind: "exception",
                  index: index,
                  title: "Режим на эту дату"
                }, null, 8, ["index"])
              ]))
            }), 128)),
            (!draft.value.exceptions.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Особых дат нет. Действует недельный режим. "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-branch-feedback", feedback.value && (feedback.value.result.ok ? 'w-notice' : 'w-error')]),
            role: feedback.value?.result.ok === false ? 'alert' : 'status',
            "aria-live": "polite"
          }, [
            (feedback.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(feedbackText.value), 1),
                  (blockedCount.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Ячеек без пациента вне нового режима: " + _toDisplayString(blockedCount.value) + ". Они останутся в календарях и будут недоступны для записи. ", 1))
                    : _createCommentVNode("", true),
                  (conflicts.value.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conflicts.value, (conflict, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(conflict.date || conflict.slot?.date || '') + " " + _toDisplayString(conflict.start || conflict.slot?.start || '') + " " + _toDisplayString(conflict.message || 'Есть запись пациента за пределами нового режима.'), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 10, _hoisted_21),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "w-button",
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(store).previewBranch()))
            }, " Проверить изменения "),
            _createElementVNode("button", {
              class: "w-button primary",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(store).saveBranch()))
            }, " Сохранить режим ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})